<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        If it takes
        <number-value :value="volBase" unit="\text{mL}" />
        of a
        <number-value :value="concBase" unit="\text{M}" />
        strong base to exactly neutralize
        <chemical-latex content="20.00\text{mL}" />
        of an acidic solution of unknown concentration, what is the concentration of the acid?
      </p>

      <calculation-input
        v-model="inputs.studentAnswer"
        prepend-text="$\text{[Acid]:}$"
        append-text="$\text{M}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'OleMiss116_PL7_Q7part3',
  components: {
    ChemicalLatex,
    CalculationInput,
    NumberValue,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswer: null,
      },
    };
  },
  computed: {
    volBase() {
      return this.taskState.getValueBySymbol('volBase').content;
    },
    concBase() {
      return this.taskState.getValueBySymbol('concBase').content;
    },
  },
};
</script>
